import { Theme } from '../../ITheme';
import slotTheme from '../../slot.theme';

const eyeOfTheReelsTheme: Theme = {
  ...slotTheme, // inherit all defaults from slotTheme
  colors: {
    ...slotTheme.colors,
    background: '#1C0F2E', // mystical purple
    primary: '#DAA520', // golden symbols
    secondary: '#4B0082', // indigo accent
    text: '#E6E6E6', // light gray text
    overlay: 'rgba(28,15,46,0.85)', // mystical overlay
    border: '#DAA52033', // gold transparent border
  },
  fonts: {
    ...slotTheme.fonts,
    primary: "'Cinzel Decorative', serif",
    button: "'Cinzel Decorative', serif",
  },
  uiElements: {
    ...slotTheme.uiElements,
    button: {
      ...slotTheme.uiElements.button,
      borderRadius: '5px',
      padding: '12px 20px',
      fontSize: '16px',
    },
    card: {
      ...slotTheme.uiElements.card,
      borderRadius: '14px',
      shadow: '0 4px 12px rgba(218,165,32,0.25)',
    },
    modal: {
      ...slotTheme.uiElements.modal,
      borderRadius: '14px',
      background: '#2D1A44',
    },
  },
};

export default eyeOfTheReelsTheme;
